import { render, staticRenderFns } from "./BundledDBEditor.vue?vue&type=template&id=34ddcfcc&scoped=true"
import script from "./BundledDBEditor.vue?vue&type=script&lang=js"
export * from "./BundledDBEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ddcfcc",
  null
  
)

export default component.exports